import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { Section, SectionHeading, Reveal } from "@/components/primitives";
import { trackEvent } from "@/lib/api";
import { ArrowRight } from "@phosphor-icons/react";

const VISION = [
  "Expand the technology.", "Increase active users.", "Increase available market data.",
  "Improve AI models.", "Expand supported markets.", "Improve execution infrastructure.",
  "Build a global technology ecosystem.",
];

export default function About() {
  useEffect(() => {
    trackEvent("page_view", { page: "about" });
  }, []);
  return (
    <div>
      <PageHeader
        eyebrow="About Quantum Scalp"
        title="Sophisticated arbitrage infrastructure shouldn't be limited to large firms."
        sub="Quantum Scalp was built around a simple idea: make sophisticated arbitrage technology accessible through a scalable SaaS platform."
      />

      <Section grid>
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <img
              src="https://images.unsplash.com/photo-1785682231847-93265d8e633d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxzZXJ2ZXIlMjByb29tJTIwZGFyayUyMGJsdWV8ZW58MHx8fHwxNzg2NzQ2MDk3fDA&ixlib=rb-4.1.0&q=85"
              alt="Infrastructure"
              loading="lazy"
              className="rounded-2xl border border-white/10 w-full object-cover aspect-[4/3]"
            />
          </Reveal>
          <Reveal delay={0.1}>
            <SectionHeading eyebrow="Our Foundation" title="One technology ecosystem." />
            <p className="mt-5 text-[#94A3B8] leading-relaxed">
              The company combines artificial intelligence, quantitative market analysis, automated execution,
              blockchain infrastructure, cloud computing, and software engineering into one ecosystem. The
              long-term objective is to continuously improve Q-Core through better data, research, infrastructure,
              and engineering.
            </p>
            <Link to="/team" className="mt-6 inline-flex items-center gap-2 text-sm text-[#2DD4BF] hover:text-white transition-colors">
              Meet the team <ArrowRight size={15} weight="bold" />
            </Link>
          </Reveal>
        </div>
      </Section>

      <Section>
        <div className="relative rounded-2xl border border-white/10 bg-gradient-to-b from-[#0A0B10] to-[#08090F] p-8 md:p-14 overflow-hidden" data-testid="vision-section">
          <div className="absolute inset-0 qs-grid opacity-20 pointer-events-none" aria-hidden="true" />
          <div className="relative">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#2DD4BF] mb-5">Company Vision</p>
            <h2 className="text-3xl md:text-5xl font-black text-white leading-[1.05] max-w-3xl">
              Build Once. Learn Continuously. Scale Globally.
            </h2>
            <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {VISION.map((v, i) => (
                <Reveal key={v} delay={i * 0.05}>
                  <div className="flex items-center gap-3 rounded-lg border border-white/10 bg-white/[0.02] px-4 py-3.5">
                    <span className="font-mono text-xs text-[#0E9E90]">{String(i + 1).padStart(2, "0")}</span>
                    <span className="text-sm text-white">{v}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}
